var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['full-icon-button', _vm.emphasis],on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.icon)?_c('svgicon',{staticClass:"icon",attrs:{"icon":_vm.icon}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }